import React from 'react'
import commonStyles from "../../AddPayerCommonStyles.styles";
import Heading from '../../../../../components/heading/Heading';
import { HEADING } from '../../../../../components/heading/constants/constants';
import TextInput from '../../../../../components/input/textinput/TextInput';
import GetOptionalInfoStyles from './GetOptionalInfo.styles';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, setOptionalInformation } from '../../AddPayerSlice';
import { generalValidator } from '../../../../../../libs/utility/validators/GeneralValidator';
import { componentKey as authenticationSliceKey } from '../../../../authentication/AuthenticationSlice';
import { ShowForAllowedUsersOnly } from '../../../../wrappers/ShowForAllowedUsersOnly';
import { USER_TYPE } from '../../../../../../libs/customhooks/constants';

export default function GetOptionalInfo({ payerLabel = 'Payer' }) {

    const { optionalInformation } = useSelector((state) => state[componentKey]);
    const { signedInUser } = useSelector(state => state[authenticationSliceKey])
    const dispatch = useDispatch();

    const onChangehandler = (event, rules) => {
        const { name, value } = event.target;

        if (rules) {
            const errors = generalValidator.validate(value, rules);
            dispatch(setOptionalInformation({ [name]: { value, errors, rules } }));
        } else {
            dispatch(setOptionalInformation({ [name]: { value } }));
        }
    };

    return (
        <>
            <div style={commonStyles.container}>
                <div>
                    <Heading type={HEADING.H1}>Do any of these exceptional instances apply to you?</Heading>
                    {!signedInUser?.MultiplePayerLocation && !signedInUser?.IsPayerClient ? <p>{`It’s OK to skip this step. You can always add this later !`}</p> : null}
                </div>

                <div style={commonStyles.formContainer}>
                    <div style={GetOptionalInfoStyles.formRow}>
                        <div style={GetOptionalInfoStyles.fieldContainer}>
                            <TextInput
                                name="StateID"
                                label={`File state tax for this ${payerLabel}`}
                                placeHolder="Withholding state tax ID"
                                value={optionalInformation.StateID?.value}
                                rules={optionalInformation?.StateID?.rules}
                                errors={optionalInformation.StateID?.errors}
                                onChangeCb={onChangehandler}
                                formSubmitted={optionalInformation.allRequiredFieldsTouched}
                            />
                        </div>
                        <div style={GetOptionalInfoStyles.stateContainer}>
                            <TextInput
                                name="ClientID"
                                label="Keep track of client using identification number (ID)"
                                placeHolder="Client ID"
                                value={optionalInformation.ClientID?.value}
                                onChangeCb={onChangehandler}
                                rules={optionalInformation?.ClientID?.rules} // required field for Enterprise users
                                errors={optionalInformation.ClientID?.errors}
                                formSubmitted={optionalInformation.allRequiredFieldsTouched}
                            />
                        </div>
                    </div>

                    <div style={GetOptionalInfoStyles.formRow}>
                        <div style={GetOptionalInfoStyles.fieldContainer}>
                            <TextInput
                                name="DisregardedEntity"
                                label="DisregardedEntity"
                                placeHolder="Disregarded entity name"
                                value={optionalInformation.DisregardedEntity?.value}
                                onChangeCb={onChangehandler}
                                rules={optionalInformation?.DisregardedEntity?.rules} // required field for Enterprise users
                                errors={optionalInformation.DisregardedEntity?.errors}
                                formSubmitted={optionalInformation.allRequiredFieldsTouched}
                            />
                        </div>
                        <div style={GetOptionalInfoStyles.stateContainer}>
                            <ShowForAllowedUsersOnly allowedUsers={[USER_TYPE.ENTERPRISE_USER, USER_TYPE.MEMBER_USER]}>
                                <TextInput
                                    name="GroupID"
                                    label="Group ID"
                                    placeHolder="Enter group ID"
                                    value={optionalInformation.GroupID?.value}
                                    onChangeCb={onChangehandler}
                                    formSubmitted={optionalInformation.allRequiredFieldsTouched}
                                />
                            </ShowForAllowedUsersOnly>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}